
























































































































import Vue from 'vue'
import {
  MasterlinkTenantServiceProxy,
  Tenant
} from '@/service-proxies/app-v2/system.service-proxies'
import {
  isCellphoneNo
} from '@/utils/validate'
const TenantService = new MasterlinkTenantServiceProxy()

export default Vue.extend({
  data() {
    return {
      form: this.$form.createForm(this),
      formData: {},
      iconLoading: false
    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    tenantClasses: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    validateCode(rule,value,cb) {
      if(/^[a-zA-Z][\w_-]{2,11}$/.test(value)) {
        cb()
      }else {
        cb(this.$t("page_tenant_input_code_tip"))
      }
    },
    validatePhone(rule: any, value: any, callback: any) {
      if (!isCellphoneNo(value)) {
        callback(this.$t('page_tenant_input_the_correct_mobile_number'))
      }
      callback()
    },
    onClose() {
      this.$emit('closemodal', false)
      this.form.resetFields()
    },
    onSave() {
      this.form.validateFields((err: any, values: any) => {
        if (!err) {
          this.iconLoading = true
          TenantService.createTenant(values)
            .then(res => {
              this.$message.success(this.$t('page_tenant_have_been_saved'))
              this.form.resetFields()
              this.$emit('closemodal', true)
            })
            .finally(() => (this.iconLoading = false))
        }
      })
    }
  }
})
